import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAtom } from "jotai";

import {
  interpolateString,
  titleCase,
  type Noticeboard,
  type NoticeboardResult,
} from "shared/lib";
import {
  conversationOverrideVar,
  messagesVar,
  noticeboardDataVar,
} from "@/variables/globalVar";

import { useGetPublicConversation } from "shared/apiHooks";
import { useInitGoogleMaps } from "@/hooks";

import { PrintView } from "@/components/printView/PrintView";

export function PrintViewContainer() {
  const [searchParams] = useSearchParams();
  const identifier = searchParams.get("id") || "";

  useInitGoogleMaps();

  const [conversation, setConversationOverrideVar] = useAtom(
    conversationOverrideVar,
  );
  const [noticeboardData, setNoticeboardDataVar] = useAtom(noticeboardDataVar);
  const [messages, setMessagesVar] = useAtom(messagesVar);

  const { data: publicConversationResponse, isLoading } =
    useGetPublicConversation({
      path: { conversation_identifier: identifier.toLowerCase() },
    });

  useEffect(() => {
    if (publicConversationResponse?.data) {
      console.log(
        "<PrintView> publicConversationResponse",
        publicConversationResponse.data,
      );

      setConversationOverrideVar(publicConversationResponse.data);

      setMessagesVar(publicConversationResponse.data.messages || []);

      const noticeboardArray = publicConversationResponse.data
        .noticeboard as unknown as Array<NoticeboardResult>;
      setNoticeboardDataVar(
        noticeboardArray.reduce((noticeboard, result) => {
          noticeboard[result.expert_name] = result;
          return noticeboard;
        }, {} as Noticeboard),
      );
    }
  }, [publicConversationResponse]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    console.log("<PrintView> noticeboardData", noticeboardData);
  }, [noticeboardData]);

  useEffect(() => {
    if (conversation?.address) {
      document.title = interpolateString(
        "Planning Enquiry Report for {{address}}",
        {
          address: titleCase(conversation.address),
        },
      );
    }
  }, [conversation]);

  return (
    <PrintView
      conversation={conversation}
      isLoading={isLoading}
      messages={messages}
      noticeboardData={noticeboardData}
    />
  );
}
